import React, { useState, useCallback } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import MdlSelectSingleStudent from "../dialog/MdlSelectSingleStudent";
import BackButton from "../ChildComponent/BackButton";

const AddOldDue = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [sessionName, setSessionName] = useState("");
  const [dueAmount, setDueAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [student_id, setStudent_id] = useState("");
  const [mStudentDetails, setSelectedStudent] = useState();
  const handleClose = () => setIsOpen(false);

  const handleSelectedStudent = useCallback((
    student_id,
    selected_item,
    session_id,
    session_name
  ) => {
    setIsOpen(false);
    setSelectedStudent(selected_item);
    setStudent_id(student_id);
  }, []);

  const handleShow = () => {
    setIsOpen(true);
  };

  const isValidInput = useCallback(() => {
    if (!student_id || !mStudentDetails) {
      myToast.notify_warning("Please select a student first!");
      return false;
    }
    if (dueAmount === "" || isNaN(parseFloat(dueAmount)) || parseFloat(dueAmount) <= 0) {
      myToast.notify_warning("Please enter a valid due amount!");
      return false;
    } else if (sessionName === "") {
      myToast.notify_warning("Please enter session name!");
      return false;
    } else if (remark === "") {
      myToast.notify_warning("Please enter a remark!");
      return false;
    }
    return true;
  }, [student_id, mStudentDetails, dueAmount, sessionName, remark]);

  const regSubmit = useCallback(() => {
    if (!isValidInput()) {
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "AddOldDue.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    setLoading(true);

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          student_id: student_id,
          due_amount: dueAmount,
          session_name: sessionName,
          remark: remark,
        },
      })
      .then((res) => {
        setLoading(false);
        if (res.data?.api_status === "OK") {
          myToast.notify_success("Old due added successfully!");
          // Reset form
          setDueAmount("");
          setSessionName("");
          setRemark("");
          setSelectedStudent(null);
          setStudent_id("");
        } else {
          myToast.notify_warning(res.data?.api_remark || "Failed to add old due");
        }
      })
      .catch((error) => {
        setLoading(false);
        myToast.notify_error("Error adding old due");
        console.error("Error adding old due:", error);
      });
  }, [isValidInput, student_id, dueAmount, sessionName, remark]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div className="content-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" />
              <a href="#">Add Old Due</a>
            </li>
          </ul>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <BackButton />
        </div>
      </div>

      <div
        className="bg_page_white_rounded box_shadow animated fadeInUp"
        style={{ "--mMargin": "30px", padding: "24px" }}
      >
        {/* Student Selection Section */}
        <section style={{ marginBottom: "24px" }}>
          <button
            onClick={handleShow}
            style={{
              width: "100%",
              padding: "20px",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
              border: "none",
              borderRadius: "12px",
              color: COLORS.white,
              fontSize: "16px",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.primary_color_shade4}80`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary_color_shade3}60`;
            }}
          >
            <i className="fa fa-user-plus" style={{ fontSize: "20px" }} />
            Select Student
          </button>
        </section>

        {isOpen && (
          <MdlSelectSingleStudent
            action={handleClose}
            action2={handleSelectedStudent}
          />
        )}

        {/* Student Profile Section */}
        {mStudentDetails && (
          <section style={{ marginBottom: "24px" }}>
            <div style={{
              background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey1 || "#F5F5F5"} 100%)`,
              border: `2px solid ${COLORS.primary_color_shade6 || "#039BE5"}`,
              borderRadius: "16px",
              padding: "16px",
              boxShadow: `0 4px 16px rgba(0, 0, 0, 0.08)`,
              position: "relative",
              overflow: "hidden",
            }}>
              {/* Decorative elements */}
              <div style={{
                position: "absolute",
                top: "-50px",
                right: "-50px",
                width: "200px",
                height: "200px",
                background: "rgba(11, 181, 244, 0.05)",
                borderRadius: "50%",
                filter: "blur(40px)",
              }}></div>

              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                position: "relative",
                zIndex: 1,
                flexWrap: "wrap",
              }}>
                {/* Student Image */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    border: `3px solid ${COLORS.primary_color_shade6 || "#039BE5"}`,
                    padding: "3px",
                    background: COLORS.white,
                    boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                  }}>
                    <img
                      src={mStudentDetails.student_img_path || ""}
                      alt={mStudentDetails.stu_name || "Student"}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        if (!e.target.nextSibling) {
                          const fallback = document.createElement("div");
                          fallback.style.cssText = `
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                            background: linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade4} 100%);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #fff;
                            font-size: 32px;
                            font-weight: 700;
                          `;
                          fallback.textContent = mStudentDetails.stu_name?.charAt(0)?.toUpperCase() || "S";
                          e.target.parentNode.appendChild(fallback);
                        }
                      }}
                    />
                  </div>
                  <div style={{
                    position: "absolute",
                    bottom: "0",
                    right: "0",
                    background: COLORS.primary_color_shade6 || "#039BE5",
                    color: COLORS.white,
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "11px",
                    fontWeight: "600",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                    border: "2px solid #fff",
                  }}>
                    {mStudentDetails.student_enrollment_no || ""}
                  </div>
                </div>

                {/* Student Details */}
                <div style={{ flex: 1, minWidth: "200px" }}>
                  <h4 style={{
                    margin: "0 0 8px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: COLORS.black8 || "#333333",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}>
                    <i className="fa fa-user" style={{ color: COLORS.primary_color_shade6, fontSize: "16px" }} />
                    {mStudentDetails.stu_name || ""}
                  </h4>
                  <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginBottom: "0",
                  }}>
                    {mStudentDetails.father_name && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 12px",
                        background: COLORS.primary_color_shade1 || "#B3E5FC",
                        borderRadius: "8px",
                        border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                      }}>
                        <i className="fa fa-user-circle" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                        <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                          Father: {mStudentDetails.father_name}
                        </span>
                      </div>
                    )}
                    {mStudentDetails.board_name && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 12px",
                        background: COLORS.primary_color_shade1 || "#B3E5FC",
                        borderRadius: "8px",
                        border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                      }}>
                        <i className="fa fa-book" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                        <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                          {mStudentDetails.board_name}
                        </span>
                      </div>
                    )}
                    {mStudentDetails.medium_name && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 12px",
                        background: COLORS.primary_color_shade1 || "#B3E5FC",
                        borderRadius: "8px",
                        border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                      }}>
                        <i className="fa fa-language" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                        <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                          {mStudentDetails.medium_name}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Roll No & Class */}
                <div style={{
                  textAlign: "center",
                  padding: "12px 18px",
                  background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
                  borderRadius: "12px",
                  color: COLORS.white,
                  boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                  minWidth: "120px",
                }}>
                  <div style={{ marginBottom: "8px" }}>
                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", opacity: 0.9 }}>Roll No.</p>
                    <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                      {mStudentDetails.student_roll_no || ""}
                    </h4>
                  </div>
                  <div style={{
                    paddingTop: "8px",
                    borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                  }}>
                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", opacity: 0.9 }}>Class</p>
                    <h4 style={{ margin: 0, fontSize: "16px", fontWeight: "700" }}>
                      {mStudentDetails.class_name || ""}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Form Section */}
        {mStudentDetails && (
          <section>
            <h4 style={{
              marginBottom: "20px",
              fontSize: "18px",
              fontWeight: "600",
              color: COLORS.black8 || "#333333",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}>
              <i className="fa fa-edit" style={{ color: COLORS.primary_color_shade6 }} />
              Old Due Details
            </h4>

          <div style={{
            background: COLORS.white,
            border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {/* Due Amount */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: COLORS.black8 || "#333333",
                }}>
                  <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Due Amount <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="number"
                  id="DueAmount"
                  value={dueAmount}
                  onChange={(e) => setDueAmount(e.target.value)}
                  placeholder="Enter due amount"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "16px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>

              {/* Session Name */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: COLORS.black8 || "#333333",
                }}>
                  <i className="fa fa-calendar-alt" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Session Name <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="text"
                  id="SessionName"
                  value={sessionName}
                  onChange={(e) => setSessionName(e.target.value)}
                  placeholder="Enter session name (e.g., 2023-2024)"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "16px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>

              {/* Remark */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: COLORS.black8 || "#333333",
                }}>
                  <i className="fa fa-comment" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Remark <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="text"
                  id="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Enter remark or description"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "16px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>

            {/* Submit Button */}
            <div style={{ marginTop: "24px" }}>
              <button
                onClick={regSubmit}
                disabled={!mStudentDetails || loading}
                style={{
                  width: "100%",
                  padding: "16px 24px",
                  fontSize: "18px",
                  fontWeight: "700",
                  background: (!mStudentDetails || loading)
                    ? COLORS.grey4 || "#BDBDBD"
                    : `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
                  color: COLORS.white,
                  border: "none",
                  borderRadius: "12px",
                  cursor: (!mStudentDetails || loading) ? "not-allowed" : "pointer",
                  boxShadow: (!mStudentDetails || loading)
                    ? "none"
                    : `0 4px 12px ${COLORS.primary_color_shade3}60`,
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  opacity: (!mStudentDetails || loading) ? 0.6 : 1,
                }}
                onMouseEnter={(e) => {
                  if (mStudentDetails && !loading) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.primary_color_shade4}80`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (mStudentDetails && !loading) {
                    e.currentTarget.style.transform = "";
                    e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary_color_shade3}60`;
                  }
                }}
              >
                {loading ? (
                  <>
                    <i className="fa fa-spinner fa-spin" />
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="fa fa-check-circle" />
                    Submit
                  </>
                )}
              </button>
            </div>
          </div>
        </section>
        )}
      </div>
    </div>
  );
};

export default AddOldDue;
